(async () => {
  const { text } = await import('@theme/lb-ui');
  function init(root = document) {
    for (const section of root.querySelectorAll('.vjk-cg')) {
      if (section.dataset.lbFilterBound) continue;
      section.dataset.lbFilterBound = 'true';
      const grid = section.querySelector('.vjk-cg__grid');
      const filter = section.querySelector('[data-lb-age-filter]');
      if (!grid || !filter) continue;
      const cards = [...grid.children];
      // Age bands come from the filter buttons, which are rendered from the lb-age-bands snippet.
      const bands = [...filter.querySelectorAll('[data-age-choice]')].map(button => button.dataset.ageChoice).filter(choice => choice !== 'all');
      if (!bands.length) continue;
      const pattern = new RegExp(`(?:^|\\D)(${bands.map(band => band.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|')})\\s*(?:m|months?)(?:\\b|$)`);
      const age = value => value?.toLowerCase().replace(/[–—]/g, '-').match(pattern)?.[1];
      const available = new Set(cards.map(card => age(card.dataset.lbAge)).filter(Boolean));
      if (available.size < 2) continue;
      const count = section.querySelector('[data-lb-product-count]');
      const original = count.textContent;
      for (const button of filter.querySelectorAll('[data-age-choice]')) {
        button.hidden = button.dataset.ageChoice !== 'all' && !available.has(button.dataset.ageChoice);
        button.addEventListener('click', () => {
          const selected = button.dataset.ageChoice;
          filter.querySelectorAll('[data-age-choice]').forEach(choice => choice.setAttribute('aria-pressed', String(choice === button)));
          cards.forEach(card => { card.hidden = selected !== 'all' && age(card.dataset.lbAge) !== selected; });
          count.textContent = selected === 'all' ? original : text('product_count', { count: cards.filter(card => !card.hidden).length });
        });
      }
      filter.hidden = false;
    }
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target.parentElement || document));
})();